import React from "react";
import { createPortal } from "react-dom";

const ChargesConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  chargesData = {},
  loading = false,
  codCharges = 0,
}) => {
  if (!show) return null;

  const {
    baseAmount = 0,
    walletBalance = 0,
    gstAmount = 0,
    totalCharges = 0,
    fuelCharges = 0,
    additionalRate = 0,
    additionalChargeAmount = 0,
    finalAmount = 0,
    gstPercent = 0,
  } = chargesData || {};

  const finalCharges = totalCharges + codCharges;

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          width: 400,
          borderRadius: 10,
          boxShadow: "0 12px 30px rgba(0,0,0,0.2)",
          padding: "18px 20px",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 14,
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: "#ff6a00",
            }}
          >
            Check Charges
          </div>

          <div
            style={{
              background: "#f2f6ff",
              color: "#1e40af",
              fontSize: 13,
              padding: "4px 8px",
              borderRadius: 6,
              fontWeight: 700,
            }}
          >
            Wallet: ₹{Number(walletBalance).toFixed(2)}
          </div>
        </div>

        {/* Charges */}
        <div style={{ fontSize: 14, marginBottom: 12 }}>
          <Row label="Order Amount" value={`₹${Number(baseAmount).toFixed(2)}`} />
          <Row label="Fuel Charges" value={`₹${Number(fuelCharges).toFixed(2)}`} />
          <Row label="COD Charges" value={`₹${Number(codCharges).toFixed(2)}`} />
          {/* <Row label="Additional Charges (Per KG)" value={`₹${Number(additionalRate).toFixed(2)}`} /> */}
          <Row label="Additional Weight Charges" value={`₹${Number(additionalChargeAmount).toFixed(2)}`} />
          {/* <Row label="Final Amount" value={`₹${Number(finalAmount).toFixed(2)}`} /> */}
          <Row label={`GST (${Number(gstPercent || 0).toFixed(0)}%)`} value={`₹${Number(gstAmount).toFixed(2)}`} />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: 700,
              borderTop: "1px dashed #ddd",
              marginTop: 6,
              paddingTop: 10,
              fontSize: 15,
            }}
          >
            <span>Total Charges</span>
            <span>₹{Number(finalCharges).toFixed(2)}</span>
          </div>
        </div>

        {/* Footer text */}
        <div
          style={{
            textAlign: "center",
            fontSize: 13,
            color: "#555",
            marginBottom: 12,
          }}
        >
          Are you sure you want to place the order?
        </div>

        {/* Actions */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              padding: "8px 18px",
              borderRadius: 6,
              border: "none",
              background: "#e5e7eb",
              color: "#111",
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            style={{
              padding: "8px 18px",
              borderRadius: 6,
              border: "none",
              background: "#ff6a00",
              color: "#fff",
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            {loading ? "Placing..." : "Submit"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

const Row = ({ label, value }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      padding: "6px 0",
      color: "#444",
    }}
  >
    <span>{label}</span>
    <span>{value}</span>
  </div>
);

export default ChargesConfirmationModal;
